import { makeFieldStyleSelector } from "@client/content/modules/selectors";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { ScreenType } from "@client/types";
import { type AppState } from "@client/types/AppState";
import { setError, systemAssigned, systemAssignFailed } from "../actions";
import { localStateSelector } from "../selectors";
import { type Purchase } from "../types";
import Component, { type ActionsProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const fieldStyleSelector = makeFieldStyleSelector();
  const labelPlacementSelector = getSettingValueSelector(TargetSelector.Entity, "placement", "label");

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    const apiInfo = apiInfoSelector(state, props);

    return {
      ...props,
      apiInfo,
      error: localState.error,
      fieldStyle: fieldStyleSelector(state, props),
      firstStepData: localState.firstStepData!,
      isLabelInside: labelPlacementSelector(state, props) !== "label-outside-left",
      isMobile: state.viewport.screen === ScreenType.Mobile,
      package: localState.package!,
      payment: localState.payment!,
      trial: localState.trial,
      verifyResult: localState.verfiyResult!
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionsProps => ({
  dismissError: () => dispatch(setError(props, null)),
  next: (res: Purchase.Api.AssignSystemResponse) => dispatch(systemAssigned(props, res)),
  failed: (error: Purchase.Api.ErrorCode) => dispatch(systemAssignFailed(props, error))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
